<div
  class="bn-dialog {{ data?.additionalClasses || '' }}"
  [ngClass]="{
    'bn-dialog--text-center': data?.textCenter,
  }">
  <div class="bn-dialog__icon bn-dialog__icon--{{ data?.contextType }}">
    @if (data?.gradientIcon) {
      <fa-icon
        class="gradientIcon"
        [icon]="data?.icon ?? 'circle-question'"
        [ngClass]="data?.contextType ? 'gradient-' + data?.contextType : ''" />
    } @else {
      <fa-icon [icon]="data?.icon ?? 'circle-question'" />
    }
  </div>

  <div class="bn-dialog__title">{{ data?.title }}</div>
  <div class="bn-dialog__body">
    <div [innerHtml]="data?.description | sanitizeHtml: ['p', 'br', 'span', 'div', 'strong', 'b', 'em', 'i', 'u'] : ['class']"></div>
  </div>

  @if (data?.checkbox; as checkbox) {
    <hr class="bn-divider my-4" />
    <div class="bn-dialog__body pt-0 text-start">
      <bn-web-ui-switch
        [label]="checkbox.label"
        [(ngModel)]="checkbox.checked" />
      @if (checkbox.description) {
        <p
          class="bn-form__description"
          [innerHTML]="checkbox.description | sanitizeHtml: ['p', 'br', 'span', 'div', 'strong', 'b', 'em', 'i', 'u'] : ['class']"></p>
      }
    </div>
  }

  <div class="bn-dialog__actions row g-2">
    @if (data?.confirmButtonName) {
      <div class="col mt-0">
        <button
          bn-web-ui-button
          size="lg"
          type="button"
          [fullWidth]="true"
          [itemStyle]="data?.contextType === 'danger' ? 'danger' : 'primary'"
          [loading]="isLoading()"
          (click)="onSubmit()">
          {{ data?.confirmButtonName }}
        </button>
      </div>
    }

    @if (!data?.hideCloseButton) {
      <div class="col mt-0">
        <button
          bn-web-ui-button
          size="lg"
          [fullWidth]="true"
          [itemStyle]="data?.closeButtonStyle ?? 'stroke'"
          (click)="onCloseDialog()">
          {{ data?.closeButtonName ?? 'Cancel' }}
        </button>
      </div>
    }
  </div>
</div>
